export default [
    {
        path: 'gerenciamento',
        component: () => import(
            /* webpackChunkName: 'manutencao-gerenciamento' */
            '@/views/manutencao/gerenciamento/Index'
        ),
        redirect: 'gerenciamento/index',
        children: [
            {
                name: 'manutencao-gerenciamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'manutencao-gerenciamento' */
                    '@/views/manutencao/gerenciamento/List.vue'
                ),
            },
            {
                name: 'manutencao-gerenciamento-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'manutencao-gerenciamento' */
                    '@/views/manutencao/gerenciamento/Form.vue'
                ),
            },
            {
                name: 'manutencao-gerenciamento-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'manutencao-gerenciamento' */
                    '@/views/manutencao/gerenciamento/Form.vue'
                ),
            },
        ],
    },
]